import React, {useState, useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { Button } from '../index';
import ContactUsLetter from 'assests/images/contact-us.png';
import LogoFaded from 'assests/images/logo-faded.png';
import './footer.less';

import ContactUs from 'components/ContactUs/contactus';
import { FooterPackagesList,FooterMessagesList,FooterReportsList,FooterProfileList,FooterSupportList,FooterBlogList } from 'constants/menu.const';




const Footer = (props) => {
  const [modalSendUs, setModalSendUs] = useState(false);

  return (
    <div className={classNames('footer', { 'footer--v2': props.typeV2 })}>
      {modalSendUs &&  (
      <ContactUs visible={modalSendUs} onClose={e=> setModalSendUs(false)}  onOpen={e=> setModalSendUs(true)}  />)}

      <div className="container">
        {props.typeV2 ? (
          <div className="footer__bottom">
            <figure>
              <img src={LogoFaded} alt="Logo" />
            </figure>
            <span>Turkcell Mesaj Üssü 2021 </span>
            <NavLink to="/">Yardım</NavLink>
          </div>
        ) : (
          <>
            <div className="footer__top">
              <div className="footer-list__item footer-list__item--reports">
                <strong>{FooterReportsList.title}</strong>
                <ul>
                  {FooterReportsList.items.map((item, index) => (
                    <li key={'reports-' + index}>
                      <NavLink to={item.link}>{item.text}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer-list__item footer-list__item--packages">
                <strong>{FooterPackagesList.title}</strong>
                <ul>
                  {FooterPackagesList.items.map((item, index) => (
                    <li key={'packages-' + index}>
                      <NavLink to={item.link}>{item.text}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer-list__item footer-list__item--messages">
                <strong>{FooterMessagesList.title}</strong>
                <ul>
                  {FooterMessagesList.items.map((item, index) => (
                    <li key={'messages-' + index}>
                      <NavLink to={item.link}>{item.text}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer-list__item footer-list__item--profile">
                <strong>{FooterProfileList.title}</strong>
                <ul>
                  {FooterProfileList.items.map((item, index) => (
                    <li key={'profile-' + index}>
                      <NavLink to={item.link}>{item.text}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className='footer-list__item footer-list__item--blog'>
                <strong>{FooterBlogList.title}</strong>
                <ul>
                  {FooterBlogList.items.map((item, index) => (
                    <li key={'blog-'+index}>
                      <NavLink to={item.link} target={'_blank'}>{item.text}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer-list__item footer-list__item--support">
                <strong>{FooterSupportList.title}</strong>
                <ul>
                  {FooterSupportList.items.map((item, index) => (
                    <li key={'support-' + index}>
                      <NavLink to={item.link}>{item.text}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="contact-us">
                <figure>
                  <img src={ContactUsLetter} />
                </figure>
                <Button key="confirm" type="ghost" onClick={() => setModalSendUs(true)}>
                  Bize Ulaşın
                </Button>
              </div>
            </div>
            <div className="footer__bottom">
              <figure>
                <img src={LogoFaded} alt="Logo" />
              </figure>
              <span>Turkcell Mesaj Üssü 2023 </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Footer;
